<template>
  <li class="widget">
    <div class="title">
      <h5>Testimonial</h5>
    </div>
    <div class="content">
      <blockquote>
        <p>{{ test.content }}</p>
        <cite>{{ test.author }}<b>, {{ test.type }}</b></cite>
      </blockquote>
    </div>
  </li>
</template>

<script>
export default {
  props: ["test"],
  data() {
    return {};
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// testimonial.vue?a89708c2